// extracted by mini-css-extract-plugin
module.exports = {"slider":"c2YJpAe","card":"c5Q4rlA"};